import draftToHtml from 'draftjs-to-html';

const isAccessible = (accessKeys, accessKey) => {
  let result = false;

  for (let i = 0; i < accessKeys.length; i++) {
    // If accessKey is an array, check if current code is inside it
    if (Array.isArray(accessKey)) {
      if (accessKey.includes(accessKeys[i].code)) {
        result = true;
        break;
      }
    } else {
      // If accessKey is a single string
      if (accessKeys[i].code === accessKey) {
        result = true;
        break;
      }
    }
  }

  return result;
}

// const convertUrlsToLinks = (htmlContent) => {
//   // Use a regular expression to convert words starting with "http" or "https" to links
//   const clickableHtmlContent = htmlContent.replace(
//     /\b(?:https?|ftp):\/\/[^\s<>]+/g,
//     (url) => `<a href="${url}" target="_blank">${url}</a>`
//   );
//   return clickableHtmlContent;
// }


const convertUrlsToLinks = (htmlContent) => {
  const clickableHtmlContent = htmlContent.replace(
    /(\b(?:https?|ftp|mailto|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])(?![^<]*>|[^<>]*<\/)/ig,
    (url) => `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`
  );

  return clickableHtmlContent;
};

const convertTargetSelfToBlank = (htmlContent) => {
  return htmlContent.replace(/<a(.*?)target="_self"(.*?)>/ig, '<a$1target="_blank"$2>');
}

const blockstoHtml = (data) => {
  const htmlContent = draftToHtml(data);
  const htmlWithClickableLinks = convertUrlsToLinks(htmlContent);
  const htmlWithTargetConversion = convertTargetSelfToBlank(htmlWithClickableLinks); 
  return htmlWithTargetConversion;
}

// Extract base64 images from HTML and return both base64 data and full img tag
const extractBase64Images = (html) => {
  if (!html || typeof html !== 'string') {
    return [];
  }

  // Handle both single and double quotes
  const regex = /<img([^>]+)src=["']data:image\/([^;]+);base64,([^"']+)["']([^>]*)>/gi;
  const images = [];
  let match;
  let index = 0;

  while ((match = regex.exec(html)) !== null) {
    const beforeSrc = match[1]; // Attributes before src
    const imageType = match[2]; // jpeg, png, etc.
    const base64Data = match[3]; // The base64 string
    const afterSrc = match[4]; // Attributes after src
    const fullTag = match[0]; // The entire img tag
    
    images.push({
      base64: base64Data,
      type: imageType,
      beforeSrc: beforeSrc,
      afterSrc: afterSrc,
      fullTag: fullTag,
      index: index++,
      fileName: `sc_ticket_image_${index - 1}.${imageType === 'jpeg' || imageType === 'jpg' ? 'jpg' : imageType}`
    });
  }

  return images;
}

// Replace base64 images with placeholders that reference attachment files
const replaceBase64WithPlaceholders = (html, imageInfos) => {
  if (!html || typeof html !== 'string' || !imageInfos || imageInfos.length === 0) {
    return html;
  }

  let result = html;
  
  imageInfos.forEach((imageInfo) => {
    // Replace the full img tag with a placeholder that includes the file name
    result = result.replace(
      imageInfo.fullTag,
      `<img${imageInfo.beforeSrc} src="img-src/attachments/${imageInfo.fileName}"${imageInfo.afterSrc}>`
    );
  });

  return result;
}

// Convert base64 → File
const base64ToFile = (base64, imageType, filename) => {
  const byteString = atob(base64);
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const intArray = new Uint8Array(arrayBuffer);

  for (let i = 0; i < byteString.length; i++) {
    intArray[i] = byteString.charCodeAt(i);
  }

  // Determine MIME type based on image type
  const mimeType = imageType === 'jpeg' || imageType === 'jpg' 
    ? 'image/jpeg' 
    : `image/${imageType}`;

  return new File([arrayBuffer], filename, { type: mimeType });
}

const obj = {
  isAccessible,
  blockstoHtml,
  extractBase64Images,
  replaceBase64WithPlaceholders,
  base64ToFile,
}

export default obj;





  